const _ = "styles-module__icon___JfTly", s = {
  icon: _,
  "icon--xs-tiny": "styles-module__icon--xs-tiny___d-h5a",
  "icon--x-tiny": "styles-module__icon--x-tiny___obJ-D",
  "icon--tiny": "styles-module__icon--tiny___VSnfw",
  "icon--small": "styles-module__icon--small___uSfH1",
  "icon--medium": "styles-module__icon--medium___35L7U",
  "icon--large": "styles-module__icon--large___YFzxL",
  "icon--x-large": "styles-module__icon--x-large___0JTrB",
  "icon--xx-large": "styles-module__icon--xx-large___pOmUP",
  "icon--fluid": "styles-module__icon--fluid___B5NsP",
  "icon--svg--primary": "styles-module__icon--svg--primary___YxAeD",
  "icon--svg--primary-blue": "styles-module__icon--svg--primary-blue___fKBkz",
  "icon--svg--primary-dark": "styles-module__icon--svg--primary-dark___VN7G7",
  "icon--svg--primary-light": "styles-module__icon--svg--primary-light___v3jUQ",
  "icon--svg--primary-brand": "styles-module__icon--svg--primary-brand___YxhoZ",
  "icon--svg--secondary": "styles-module__icon--svg--secondary___UBpB-",
  "icon--svg--secondary-50": "styles-module__icon--svg--secondary-50___4DIw9",
  "icon--svg--secondary-100": "styles-module__icon--svg--secondary-100___dKO-d",
  "icon--svg--secondary-200": "styles-module__icon--svg--secondary-200___c5h2v",
  "icon--svg--secondary-300": "styles-module__icon--svg--secondary-300___hoql-",
  "icon--svg--secondary-400": "styles-module__icon--svg--secondary-400___BIve2",
  "icon--svg--secondary-500": "styles-module__icon--svg--secondary-500___6bL3i",
  "icon--svg--secondary-600": "styles-module__icon--svg--secondary-600___IkK-v",
  "icon--svg--secondary-700": "styles-module__icon--svg--secondary-700___QffZN",
  "icon--svg--secondary-800": "styles-module__icon--svg--secondary-800___m4jZT",
  "icon--svg--secondary-900": "styles-module__icon--svg--secondary-900___H813I",
  "icon--svg--tertiary": "styles-module__icon--svg--tertiary___2HRks",
  "icon--svg--tertiary-50": "styles-module__icon--svg--tertiary-50___3gVRS",
  "icon--svg--tertiary-100": "styles-module__icon--svg--tertiary-100___VV4BN",
  "icon--svg--tertiary-200": "styles-module__icon--svg--tertiary-200___v3w-Q",
  "icon--svg--tertiary-300": "styles-module__icon--svg--tertiary-300___zVRIy",
  "icon--svg--tertiary-400": "styles-module__icon--svg--tertiary-400___3HLP6",
  "icon--svg--tertiary-450": "styles-module__icon--svg--tertiary-450___jg9p7",
  "icon--svg--tertiary-500": "styles-module__icon--svg--tertiary-500___8GOvb",
  "icon--svg--tertiary-600": "styles-module__icon--svg--tertiary-600___KDdTH",
  "icon--svg--tertiary-700": "styles-module__icon--svg--tertiary-700___ekdK-",
  "icon--svg--tertiary-800": "styles-module__icon--svg--tertiary-800___yPliN",
  "icon--svg--tertiary-900": "styles-module__icon--svg--tertiary-900___wUStA",
  "icon--svg--quaternary": "styles-module__icon--svg--quaternary___WpPOO",
  "icon--svg--quaternary-50": "styles-module__icon--svg--quaternary-50___0zi2x",
  "icon--svg--quaternary-100": "styles-module__icon--svg--quaternary-100___ilHoV",
  "icon--svg--quaternary-200": "styles-module__icon--svg--quaternary-200___Zw-wU",
  "icon--svg--quaternary-300": "styles-module__icon--svg--quaternary-300___yKFQQ",
  "icon--svg--quaternary-400": "styles-module__icon--svg--quaternary-400___Pa8f-",
  "icon--svg--quaternary-500": "styles-module__icon--svg--quaternary-500___lrBMb",
  "icon--svg--quaternary-600": "styles-module__icon--svg--quaternary-600___M4U0k",
  "icon--svg--quaternary-700": "styles-module__icon--svg--quaternary-700___-rCXl",
  "icon--svg--quaternary-800": "styles-module__icon--svg--quaternary-800___pKVie",
  "icon--svg--quaternary-900": "styles-module__icon--svg--quaternary-900___jiPk6",
  "icon--svg--info": "styles-module__icon--svg--info___y3XA2",
  "icon--svg--info-50": "styles-module__icon--svg--info-50___FfwqL",
  "icon--svg--info-100": "styles-module__icon--svg--info-100___JONNa",
  "icon--svg--info-200": "styles-module__icon--svg--info-200___28e1Q",
  "icon--svg--info-300": "styles-module__icon--svg--info-300___mMIY1",
  "icon--svg--info-400": "styles-module__icon--svg--info-400___oVQW3",
  "icon--svg--info-500": "styles-module__icon--svg--info-500___Uq2Ic",
  "icon--svg--info-600": "styles-module__icon--svg--info-600___XQD0c",
  "icon--svg--info-700": "styles-module__icon--svg--info-700___YOz3u",
  "icon--svg--info-800": "styles-module__icon--svg--info-800___bqiuq",
  "icon--svg--info-900": "styles-module__icon--svg--info-900___riHHy",
  "icon--svg--success": "styles-module__icon--svg--success___IxuL0",
  "icon--svg--success-50": "styles-module__icon--svg--success-50___Qt-1O",
  "icon--svg--success-100": "styles-module__icon--svg--success-100___ptsvk",
  "icon--svg--success-200": "styles-module__icon--svg--success-200___p95O0",
  "icon--svg--success-300": "styles-module__icon--svg--success-300___Lek9M",
  "icon--svg--success-400": "styles-module__icon--svg--success-400___aIHoG",
  "icon--svg--success-500": "styles-module__icon--svg--success-500___9iVwV",
  "icon--svg--success-600": "styles-module__icon--svg--success-600___rU4iL",
  "icon--svg--success-700": "styles-module__icon--svg--success-700___wSFtv",
  "icon--svg--success-800": "styles-module__icon--svg--success-800___5XoKP",
  "icon--svg--success-900": "styles-module__icon--svg--success-900___Px88U",
  "icon--svg--alert": "styles-module__icon--svg--alert___ThRt-",
  "icon--svg--alert-50": "styles-module__icon--svg--alert-50___lsWQJ",
  "icon--svg--alert-100": "styles-module__icon--svg--alert-100___UViI-",
  "icon--svg--alert-200": "styles-module__icon--svg--alert-200___rLG5-",
  "icon--svg--alert-300": "styles-module__icon--svg--alert-300___re6BN",
  "icon--svg--alert-400": "styles-module__icon--svg--alert-400___tviJo",
  "icon--svg--alert-500": "styles-module__icon--svg--alert-500___ZdSGR",
  "icon--svg--alert-600": "styles-module__icon--svg--alert-600___qKSqd",
  "icon--svg--alert-700": "styles-module__icon--svg--alert-700___Jd-lq",
  "icon--svg--alert-800": "styles-module__icon--svg--alert-800___7STkd",
  "icon--svg--alert-900": "styles-module__icon--svg--alert-900___Zt5QQ",
  "icon--svg--error": "styles-module__icon--svg--error___k8p0u",
  "icon--svg--error-50": "styles-module__icon--svg--error-50___KbSPl",
  "icon--svg--error-100": "styles-module__icon--svg--error-100___Z3xlJ",
  "icon--svg--error-200": "styles-module__icon--svg--error-200___RdNf-",
  "icon--svg--error-300": "styles-module__icon--svg--error-300___atLbd",
  "icon--svg--error-400": "styles-module__icon--svg--error-400___yyBg-",
  "icon--svg--error-500": "styles-module__icon--svg--error-500___UuYwH",
  "icon--svg--error-600": "styles-module__icon--svg--error-600___aPPeY",
  "icon--svg--error-700": "styles-module__icon--svg--error-700___WggN4",
  "icon--svg--error-800": "styles-module__icon--svg--error-800___arg7i",
  "icon--svg--error-900": "styles-module__icon--svg--error-900___Mknd3",
  "icon--svg--neutral": "styles-module__icon--svg--neutral___m-64-",
  "icon--svg--neutral-50": "styles-module__icon--svg--neutral-50___LyfCi",
  "icon--svg--neutral-100": "styles-module__icon--svg--neutral-100___zwmmH",
  "icon--svg--neutral-150": "styles-module__icon--svg--neutral-150___UGIZT",
  "icon--svg--neutral-200": "styles-module__icon--svg--neutral-200___HF5bz",
  "icon--svg--neutral-300": "styles-module__icon--svg--neutral-300___sCozg",
  "icon--svg--neutral-400": "styles-module__icon--svg--neutral-400___0Z86k",
  "icon--svg--neutral-500": "styles-module__icon--svg--neutral-500___Q-nZL",
  "icon--svg--neutral-600": "styles-module__icon--svg--neutral-600___KFdEI",
  "icon--svg--neutral-700": "styles-module__icon--svg--neutral-700___BMpSs",
  "icon--svg--neutral-800": "styles-module__icon--svg--neutral-800___6v6gx",
  "icon--svg--neutral-900": "styles-module__icon--svg--neutral-900___p0X6T",
  "icon--svg--grey": "styles-module__icon--svg--grey___x-9OM",
  "icon--svg--grey-50": "styles-module__icon--svg--grey-50___2t-Ca",
  "icon--svg--grey-100": "styles-module__icon--svg--grey-100___4aF1D",
  "icon--svg--grey-200": "styles-module__icon--svg--grey-200___Jl2-p",
  "icon--svg--grey-300": "styles-module__icon--svg--grey-300___YBOve",
  "icon--svg--grey-400": "styles-module__icon--svg--grey-400___LgpZL",
  "icon--svg--grey-500": "styles-module__icon--svg--grey-500___2L86P",
  "icon--svg--grey-600": "styles-module__icon--svg--grey-600___HPAET",
  "icon--svg--grey-700": "styles-module__icon--svg--grey-700___Te-q6",
  "icon--svg--grey-800": "styles-module__icon--svg--grey-800___JE-Bw",
  "icon--svg--grey-900": "styles-module__icon--svg--grey-900___dRFUR",
  "icon--svg--background": "styles-module__icon--svg--background___dC-DB",
  "icon--svg--background-200": "styles-module__icon--svg--background-200___kYKh2",
  "icon--svg--background-full-white": "styles-module__icon--svg--background-full-white___OsafX",
  "icon--svg--background-grey-50": "styles-module__icon--svg--background-grey-50___wzHYV",
  "icon--svg--background-neutral-50": "styles-module__icon--svg--background-neutral-50___V7VFQ",
  "icon--svg--background-grey-100": "styles-module__icon--svg--background-grey-100___eO1yc",
  "icon--svg--background-tertiary": "styles-module__icon--svg--background-tertiary___hfJl1",
  "icon--svg--background-error": "styles-module__icon--svg--background-error___-tfn4",
  "icon--svg--background-tertiary-600": "styles-module__icon--svg--background-tertiary-600___iJ8by",
  "icon--svg--background-error-600": "styles-module__icon--svg--background-error-600___nvFqo",
  "icon--svg--background-neutral-900": "styles-module__icon--svg--background-neutral-900___lte-l",
  "icon--svg--background-neutral-legacy": "styles-module__icon--svg--background-neutral-legacy___bJtce",
  "icon--svg--background-win": "styles-module__icon--svg--background-win___28Nlu",
  "icon--svg--typography": "styles-module__icon--svg--typography___sNOD-",
  "icon--svg--typography-white": "styles-module__icon--svg--typography-white___kncdo",
  "icon--svg--typography-default": "styles-module__icon--svg--typography-default___aTgpW",
  "icon--svg--typography-link": "styles-module__icon--svg--typography-link___jkK9z",
  "icon--svg--typography-error": "styles-module__icon--svg--typography-error___veyux",
  "icon--svg--typography-sucess": "styles-module__icon--svg--typography-sucess___r1UG2",
  "icon--svg--typography-disabled": "styles-module__icon--svg--typography-disabled___vG3I1",
  "icon--svg--typography-marketing": "styles-module__icon--svg--typography-marketing___MkjA1",
  "icon--svg--typography-secondary": "styles-module__icon--svg--typography-secondary___4rG-b",
  "icon--svg--icons-white": "styles-module__icon--svg--icons-white___ZghXl",
  "icon--svg--icons-dark-grey": "styles-module__icon--svg--icons-dark-grey___2oZfg",
  "icon--svg--icons-blue": "styles-module__icon--svg--icons-blue___92IG1",
  "icon--svg--icons-red": "styles-module__icon--svg--icons-red___YvC8a",
  "icon--svg--icons-success": "styles-module__icon--svg--icons-success___GgPT0",
  "icon--svg--icons-warning": "styles-module__icon--svg--icons-warning___RV3Hy",
  "icon--svg--icons-info": "styles-module__icon--svg--icons-info___4MbRb",
  "icon--svg--icons-win": "styles-module__icon--svg--icons-win___KZ4iz",
  "icon--svg--accent": "styles-module__icon--svg--accent___49ypw",
  "icon--svg--accent-orange": "styles-module__icon--svg--accent-orange___wxT53",
  "icon--svg--accent-light": "styles-module__icon--svg--accent-light___pfB4b"
};
export {
  s as default,
  _ as icon
};
